import { preselectSeatpost } from './defaultSeatpost.js';

// Build ids are positional: one "<step letter><item id>&<colour>[&<tyre width ×10>]" code per step, in step order.
export const SEPARATOR = '&';

export function parseCompositionId(id) {
  return String(id || '').split(/[a-z]/i).map(code => {
    const a = code.split(SEPARATOR).map(n => parseInt(n));
    // Allow just ID (length 1), default color to 0. Ensure ID is valid.
    if (a.length >= 1 && !isNaN(a[0])) {
      if (isNaN(a[1])) a[1] = 0;
      return a;
    }
  }).filter(a => a);
}

// options(stepId) lists the catalogue for a step; getSteps(frame) the steps that frame takes.
export function decodeComposition(id, { options, getSteps, seatposts = [], tyreWidth = w => w }) {
  const codes = parseCompositionId(id);
  if (!codes.length) return null;
  const selection = [];
  let index = (options('framesets') || []).findIndex(a => a.id === codes[0][0]);
  if (index !== -1) {
    getSteps(options('framesets')[index]).forEach((step, i) => {
      if (!codes[i]) return;
      const list = options(step.id) || [];
      if (step.id !== 'framesets') index = list.findIndex(a => a.id === codes[i][0]);
      if (index === -1) return;
      selection.push({
        props: step,
        selected: index,
        color: codes[i][1],
        tyreWidth: step.id === 'tyres' ? tyreWidth(codes[i][2] / 10) : null,
        item: Object.assign(list[index], { type: step.id, step })
      });
    });
  }
  // Older builds may lack a seatpost; never leave the saddle floating.
  const frame = selection[0] && selection[0].item;
  return frame ? preselectSeatpost(selection, seatposts, getSteps(frame)) : selection;
}

// Tyres and bottle cages are a PAIR; the stored price is the pair total.
export function entryPrice(entry) {
  const choice = entry && entry.item && entry.item.colors && entry.item.colors[entry.color];
  return choice ? choice.color && choice.color.price || choice.price || 0 : 0;
}

export function buildPrice(selection = []) {
  return selection.reduce((sum, entry) => sum + entryPrice(entry), 0);
}
